/**
 * Tiny connector around <SkillLibraryWindow /> that owns the
 * useSkillSync hook so Win95Desktop can mount the window without
 * importing Convex directly. The Settings → Skill Library tab uses the
 * same hook, so both surfaces stay in lockstep.
 */
import { SkillLibraryWindow } from './SkillLibraryWindow';
import { useSkillSync } from '../../hooks/useSkillSync';

export function SkillLibraryWindowConnected() {
  const { sync } = useSkillSync();
  return <SkillLibraryWindow onSync={() => sync()} />;
}
